import React, { useEffect, useState } from 'react'
import CreateNotification from './CreateNotification'
import UserTable from './Table/UserTable'
import NotificationTable from './Table/NotificationTable'
import { useDispatch, useSelector } from 'react-redux'
import { alertActions, notificationAction } from '../../_actions'
import View from './Modal/View';

const Notification = () => {
	const dispatch = useDispatch();
	const selector = useSelector(state => state)
	const { notification } = selector ? selector : {}
	const { user, notificationList, notificationTotal } = notification ? notification : {}
	const { list, total } = user ? user : {};
	const [inputValue, setInputValue] = useState({
		title: "", desc: ""
	});
	const [isNotiViewModal, setIsNotiViewModal] = useState(false);
	const [isNotiViewModalData, setIsNotiViewModalData] = useState(null)
	const [selectedIds, setSelectedIds] = useState([]);
	const [size, setSize] = useState(5)
	const [size2, setSize2] = useState(10)

	const [pageNo, setPageNo] = useState(1)
	const [pageNo2, setPageNo2] = useState(1)

	const [keyWord, setKeyWord] = useState('')
	const [keyWordForNotification, setKeyWordNotification] = useState('')
	const [offset1, setOffset1] = useState(0)
	const toggleViewModal = () => { setIsNotiViewModal(!isNotiViewModal); setIsNotiViewModalData(null) }
	const handleView = (data) => {
		setIsNotiViewModal(!isNotiViewModal)
		setIsNotiViewModalData(data)
	}
	useEffect(() => {
		let apiPyalod = {
			size: size,
			keyWord: keyWord,
			page: pageNo
		}
		let apiPyalodforNotification = {
			size: size2,
			keyWord: keyWordForNotification,
			page: pageNo2
		}
		dispatch(notificationAction.getUserList(apiPyalod))
		dispatch(notificationAction.getNotificationList(apiPyalodforNotification))
	}, [keyWord, keyWordForNotification])
	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const allIds = list && list.length > 0 ? list?.map((user) => user.id) : [];
			setSelectedIds([...new Set([...selectedIds, ...allIds])]);
		} else {
			const allIds = list && list.length > 0 ? list.map((user) => user.id) : [];
			setSelectedIds([...new Set(selectedIds.filter((id) => !allIds.includes(id)))]);
		}
	};

	const handleSelectUser = (id) => {
		if (selectedIds.includes(id)) {
			setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
		} else {
			setSelectedIds([...selectedIds, id]);
		}
	};

	const handleOnChange = (e) => {
		const { name, value } = e.target;
		setInputValue({ ...inputValue, [name]: value })
	}
	const handleSend = (e) => {
		e.preventDefault();
		if (selectedIds.length === 0) {
			dispatch(alertActions.error("Please select at least one user."));
			return;
		}
		let sendPayload = {
			title: inputValue?.title,
			desc: inputValue?.desc,
			ids: selectedIds
		}
		dispatch(notificationAction.sendNotification(sendPayload))
		setInputValue({ title: '', desc: "" })
		setSelectedIds([])
	};

	const handlePageClick2 = (data) => {
		const newPageNo = data.selected + 1;
		setPageNo2(newPageNo);
		let offset = Math.ceil(data.selected * size);
		setOffset1(offset);
		let apiPyalodforNotification = {
			"keyWord": keyWordForNotification,
			"page": data.selected + 1,
			"size": size2,
		}
		dispatch(notificationAction.getNotificationList(apiPyalodforNotification))

	}
	const handlePageClick = (data) => {
		const newPageNo = data.selected + 1;
		setPageNo(newPageNo);
		let apiPyalod = {
			"keyWord": keyWord,
			"page": data.selected + 1,
			"size": size,
		}
		dispatch(notificationAction.getUserList(apiPyalod))

	}
	return (
		<div className="w-full p-3 bgcolor h-screen overflow-y-auto overflow-hidden">

			<div className="space-y-4">
				<div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
					<div>
						<CreateNotification onSend={handleSend} inputValue={inputValue} handleOnChange={handleOnChange} />
					</div>
					<div className='lg:col-span-2 col-span-1'>
						<UserTable users={list} handleSelectAll={handleSelectAll} selectedIds={selectedIds} handleSelectUser={handleSelectUser} keyWord={keyWord} setKeyWord={setKeyWord} size={size} total={total} handlePageClick={handlePageClick} />
					</div>

					<div className="col-span-1 lg:col-span-3">
						<NotificationTable history={notificationList} keyword={keyWordForNotification} setKeyWord={setKeyWordNotification} total={notificationTotal} size={size2} handlePageClick={handlePageClick2} offset={offset1} handleView={handleView} />
					</div>
					{
						isNotiViewModal && (<View onClose={toggleViewModal} data={isNotiViewModalData} />)
					}
				</div>
			</div>
		</div>
	)
}

export default Notification